class VivicoCatalogue extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    const order = ['berlin skyline','seit 1972','nr. 1 an der spree','silent eye','red signal','path watcher','neuro flame','broken orbit','mind core','soundstorm','candy agent','loft vibes','fruit freak','skyline','skyline mit hfc','stadion','stadion mit hfc','aus berlin'];
    const rank = card => { const i=order.findIndex(m=>card.dataset.motif===m || card.dataset.motif.startsWith(m+' ')); return i<0 ? 100 : i; };
    this.querySelectorAll('.v-catalogue-grid').forEach(grid => {
      [...grid.querySelectorAll('[data-vivico-card]')].sort((a,b)=>rank(a)-rank(b) || a.dataset.motif.localeCompare(b.dataset.motif,'de')).forEach(card=>grid.append(card));
    });
    this.cards = [...this.querySelectorAll('[data-vivico-card]')];
    this.cards.forEach(card => {
      card.variantData = JSON.parse(card.querySelector('[data-model-variants]')?.textContent || '{}');
      const link = card.querySelector('.vivico-card__link');
      card.initialVariant = new URL(link.href).searchParams.get('variant');
      card.baseURL = link.getAttribute('href').split('?')[0];
    });
    this.selects = [...this.querySelectorAll('[data-vivico-filter]')];
    this.limit = Number(this.dataset.initialLimit || 16); this.visibleLimit = this.limit;
    const params = new URLSearchParams(location.search);
    this.selects.filter(s => s.dataset.vivicoFilter !== 'model').forEach(s => {
      if ([...s.options].some(o => o.value === params.get(s.dataset.vivicoFilter))) s.value = params.get(s.dataset.vivicoFilter);
    });
    this.buildModels();
    const model = this.querySelector('[data-vivico-filter="model"]');
    if (model && [...model.options].some(o => o.value === params.get('model'))) model.value = params.get('model');
    this.selects.forEach(s => s.addEventListener('change', () => {
      this.visibleLimit = this.limit;
      if (s.dataset.vivicoFilter !== 'model') this.buildModels();
      this.apply(); this.syncURL();
    }));
    this.querySelector('[data-load-more]')?.addEventListener('click', () => { this.visibleLimit += this.limit; this.apply(); });
    this.querySelector('[data-reset]')?.addEventListener('click', () => {
      this.selects.forEach(s => s.value = 'all'); this.visibleLimit = this.limit; this.buildModels(); this.apply(); this.syncURL();
    });
    this.apply();
  }
  filters() { return Object.fromEntries(this.selects.map(s => [s.dataset.vivicoFilter, s.value])); }
  matches(card, skipModel = false) {
    return Object.entries(this.filters()).every(([key, value]) => {
      if (value === 'all' || (skipModel && key === 'model')) return true;
      if (key === 'edition' && value === 'offbeat' && card.dataset.currentEdition === 'false' && card.dataset.kind !== 'coverup') return false;
      if (key === 'brand') return card.dataset.brands.split(' ').includes(value);
      if (key === 'model') return card.dataset.models.toLowerCase().split('||').includes(value);
      return card.dataset[key] === value;
    });
  }
  buildModels() {
    const select = this.querySelector('[data-vivico-filter="model"]'); if (!select) return;
    const current = select.value; const brand = this.filters().brand || 'all';
    const models = [...new Set(this.cards.filter(c => this.matches(c, true)).flatMap(c => c.dataset.models.split('||')).filter(m => /iphone|galaxy/i.test(m) && (brand === 'all' || (brand === 'apple' ? /iphone/i.test(m) : /galaxy/i.test(m)))))].sort((a,b) => b.localeCompare(a,'de',{numeric:true}));
    select.replaceChildren(new Option('Alle Modelle', 'all'), ...models.map(m => new Option(m, m.toLowerCase())));
    if ([...select.options].some(o => o.value === current)) select.value = current;
  }
  syncURL() {
    const url = new URL(location.href);
    this.selects.forEach(s => { const key=s.dataset.vivicoFilter; s.value === 'all' ? url.searchParams.delete(key) : url.searchParams.set(key,s.value); });
    history.replaceState(null,'',url);
  }
  displayVariant(card) {
    const model=this.filters().model;
    if (model && model !== 'all') return card.variantData[model];
    if (card.dataset.supplemental === 'true') return null;
    if (this.filters().brand === 'samsung') {
      const models=Object.keys(card.variantData).filter(m=>/galaxy|samsung/i.test(m)).sort((a,b)=>b.localeCompare(a,'de',{numeric:true}));
      return card.variantData[models[0]];
    }
    return Object.values(card.variantData).find(v=>String(v.id)===card.initialVariant);
  }
  apply() {
    const filters = this.filters();
    this.closest('.v-refresh')?.querySelectorAll('.v-case-guide__grid a').forEach(link => {
      const url = new URL(link.href);
      ['model', 'edition'].forEach(key => {
        if (filters[key] && filters[key] !== 'all') url.searchParams.set(key, filters[key]);
        else url.searchParams.delete(key);
      });
      link.href = url.pathname + url.search;
      const current = url.searchParams.get('family') === filters.family;
      link.classList.toggle('is-current', current);
      if (current) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    const seen = new Set();
    const eligible = this.cards.filter(c => this.matches(c));
    const matches = eligible.filter(c => this.displayVariant(c)?.image || c.dataset.kind === 'wallet').sort((a,b)=>Number(a.dataset.supplemental === 'true')-Number(b.dataset.supplemental === 'true')).filter(c=>{
      const key=c.dataset.motif+'|'+c.dataset.family; if(seen.has(key)) return false; seen.add(key); return true;
    }); const model = this.filters().model;
    this.cards.forEach(c => { c.hidden = true; const label=c.querySelector('[data-card-compatibility]'); if(label){ if(!label.dataset.default) label.dataset.default=label.textContent; label.textContent=model && model !== 'all' ? c.dataset.models.split('||').find(m=>m.toLowerCase()===model) || label.dataset.default : label.dataset.default; } });
    matches.slice(0,this.visibleLimit).forEach(c => {
      c.hidden=false;
      const link=c.querySelector('.vivico-card__link');
      const variant=this.displayVariant(c);
      if (variant) link.href=c.baseURL+'?variant='+variant.id;
      const media=c.querySelector('.vivico-card__media');
      if (variant?.image) {
        let img=media.querySelector('img');
        if (!img) { img=document.createElement('img'); img.loading='lazy'; media.prepend(img); }
        if (img.getAttribute('src') !== variant.image) {
          img.removeAttribute('srcset');
          img.src=variant.image;
          img.alt=c.querySelector('h3').textContent+' – '+variant.model;
          img.width=1000; img.height=1000;
        }
        media.querySelector('.v-image-missing')?.remove();
        const label=c.querySelector('[data-card-compatibility]');
        if (label) label.textContent=variant.model;
      }
    });
    this.querySelectorAll('[data-family-group]').forEach(group => {
      group.hidden = !group.querySelector('[data-vivico-card]:not([hidden])');
      group.querySelector('.v-catalogue-grid').dataset.count = group.querySelectorAll('[data-vivico-card]:not([hidden])').length;
    });
    this.querySelectorAll('[data-edition-group]').forEach(group => { group.hidden = !group.querySelector('[data-family-group]:not([hidden])'); });
    const count=this.querySelector('[data-result-count]'); if(count) count.textContent=matches.length + ' Produkte';
    const more=this.querySelector('[data-load-more]'); if(more) more.hidden=matches.length<=this.visibleLimit;
    const empty=this.querySelector('[data-empty]');
    if(empty) {
      empty.hidden=matches.length>0;
      empty.textContent=eligible.length ? 'Für dieses Gerät fehlen aktuell passende Motivbilder. Bitte wähle ein anderes Modell.' : 'Für diese Auswahl sind aktuell keine Produkte verfügbar. Wähle ein anderes Modell oder setze die Filter zurück.';
    }
  }
}
if (!customElements.get('vivico-catalogue')) customElements.define('vivico-catalogue', VivicoCatalogue);
